import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=63d8cc7a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d8cc7a')) {
      api.createRecord('63d8cc7a', component.options)
    } else {
      api.reload('63d8cc7a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=63d8cc7a", function () {
      api.rerender('63d8cc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/Index.vue"
export default component.exports